function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon_19_"
}, React.createElement("path", {
  d: "m407.5 282.5h-335c-23.5 0-42.5-19-42.5-42.5 0-23.5 19-42.5 42.5-42.5h335c23.5 0 42.5 19 42.5 42.5 0 23.5-19 42.5-42.5 42.5z"
}), React.createElement("path", {
  d: "m407.5 419.5h-335c-23.5 0-42.5-19-42.5-42.5 0-23.5 19-42.5 42.5-42.5h335c23.5 0 42.5 19 42.5 42.5 0 23.5-19 42.5-42.5 42.5z"
}), React.createElement("path", {
  d: "m407.8 145.5h-335.6c-23.3 0-42.2-18.9-42.2-42.2v-.5c0-23.3 18.9-42.2 42.2-42.2h335.5c23.3 0 42.2 18.9 42.2 42.2v.5c.1 23.3-18.8 42.2-42.1 42.2z"
}));

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "menu_x5F_bar",
    enableBackground: "new 0 0 480 480",
    height: 512,
    viewBox: "0 0 480 480",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.603e6282.svg";
export { ForwardRef as ReactComponent };